module.exports = "query DjangoQuery($wipecache:Boolean!){django(wipecache:$wipecache){wipecache}}"